module.exports = __webpack_public_path__ + "img/DE00766.9ce3b640.png";